import { render, staticRenderFns } from "./ren.vue?vue&type=template&id=53ba3b0e&scoped=true&"
import script from "./ren.vue?vue&type=script&lang=js&"
export * from "./ren.vue?vue&type=script&lang=js&"
import style0 from "./ren.vue?vue&type=style&index=0&id=53ba3b0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ba3b0e",
  null
  
)

export default component.exports